import React, { useEffect, useState } from "react";
import { Header } from "../../components/molecules";
import { AnalyticsService, notificationSchedulerTime, apiPostWithStatusCode } from '../../utils';
import { Count, Title } from "../../components/atoms";
import { routes } from "../../router/paths";
import { Link } from "react-router-dom";
import { GETNEWORDERS } from '../../api/apiConfig';
import { useLocation, useNavigate } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import { Howl } from 'howler';
import actions from "../../store/actions";
import notificationSound from '../../assets/sounds/elegant-notification-sound.mp3'

const NotificationScreen = () => {
  const [loading, setLoading] = useState(false);
  const [orderCount, setOrderCount] = useState();
  const dispatch = useDispatch();
  const numOfNewOrders = useSelector(state => state.notifications.numOfNewOrders);
  const location = useLocation();
  const navigate = useNavigate();

  const count = location?.state?.count;
  const sound = new Howl({
    src: [notificationSound]
  });
  

  useEffect(() => {
    if(location.state === undefined || location.state === null || location.key === "default"){
      navigate('/dashboard');
    }
    window.history.pushState(null, document.title, window.location.href);
    window.addEventListener('popstate', function(e){
      this.window.history.pushState(null, this.document.title, this.window.location.href);
    });
    if (count) {
      setOrderCount(count);
      dispatch(actions.updateNumOfNewOrders(count));
      dispatch(actions.viewNewOrders());
      if (location.key !== "default" && location.key) {
        sound.play();
      }
      AnalyticsService.logEvent('NOTIFICATIONS_SCREEN');
    }
  }, []);

  useEffect(() => {
    const interval = setInterval(() => getNotifications(), notificationSchedulerTime);

    return () => clearInterval(interval);
  }, [numOfNewOrders])

  const getNotifications = async () => {
    if (numOfNewOrders >=0 ) {
      const response = await apiPostWithStatusCode(GETNEWORDERS, { vendor: "The Cricket Store" });
      if (response.status === 200) {
        const res = response.data;
        let orderNo = 0;
        if (res.length > 0) {
          const newOrdersArray = res.filter(e => e.orderStatus === 0 && e.newOrder === true);
          orderNo = newOrdersArray.length;
          if (orderNo > numOfNewOrders) {
            setOrderCount(orderNo);
            sound.play();
            dispatch(actions.updateNumOfNewOrders(orderNo));
          }
        }
      }
      else {
        setTimeout(async () => {
          await getNotifications();
        }, 10000)
      }
    }
  }

  const getNewOrders = async () => {
    setLoading(true);
    const response = await apiPostWithStatusCode(GETNEWORDERS, { vendor: "The Cricket Store" });
    if (response.status === 200) {
      const res = response.data;
      if (res) {
        const newOrdersArray = res.filter(e => e.orderStatus === 0 && e.newOrder === true);
        setOrderCount(newOrdersArray.length);
      }
      dispatch(actions.updateNumOfNewOrders(count));
      setLoading(false);
    }
    else {
      setTimeout(async () => {
        await getNewOrders();
      }, 5000)
    }
  }

  return (
    <Link to={routes.dashboard} className="textDec">
      <div className="background1">
      <img style={{padding:'20px'}} width="100px" src={require('../../assets/images/logo.png')} alt="Logo image" />

        {/* <Header leftItem={"The Cricket Store"} rightItem={"Merchant's Tablet"} /> */}
        <div style={styles.centralDiv}>
          <div className={"centerAlign"}>
            <Count countNo={orderCount} isLoading={loading} />
          </div>
          <Title text={orderCount === 1 ? "NEW ORDER" : "NEW ORDERS"} className="customTitle" />
          <Title
            text={"Tap anywhere to view details"}
            className="customSubTitle"
          />
        </div>
      </div>
    </Link>
  );
};
export default NotificationScreen;
const styles = {
  centralDiv: {
    display: "flex",
    flexDirection: "column",
    height: "74%",
    justifyContent: "center",
  },
};
